<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div class="my-visits-view">
      <dashboard-header
        :text="headerText"
        :has-slot="showSwitch && !isMobile"
        :subtitle="subtitle"
      >
        <standard-switch
          class="switch-visits"
          label="Pokaż poprzednie wizyty"
          v-if="showSwitch && !isMobile"
          @switch_change="onToggle($event)"
          :initial-state="showHistoryVisits"
        />
      </dashboard-header>
      <slot />
      <router-view
        :page-type="pageType"
        :show-switch="showSwitch && isMobile"
      />
      <visits-control-button v-if="showControls" />
      <div
        class="fixed-switch"
        v-if="showSwitch && isMobile"
      >
        <standard-switch
          label="Pokaż poprzednie wizyty"
          @switch_change="onToggle($event)"
          :initial-state="showHistoryVisits"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import DashboardHeader from '~/DashboardHeader';
import VisitsControlButton from '~/VisitsControlButton';
import StandardSwitch from '~/StandardSwitch';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    DashboardHeader,
    StandardSwitch,
    VisitsControlButton,
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      showHistoryVisits: 'visit/showHistoryVisits',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    pageType() {
      const { name } = this.$route;

      if (name.includes('NextVisits')) {
        return 'next';
      } if (name.includes('HistoryVisits')) {
        return 'history';
      } if (name.includes('MyCar') || this.$route.path.includes('next/all')) {
        return 'all';
      }
      return '';
    },
    showSwitch() {
      const { path } = this.$route;

      return path.includes('visits/next/all');
    },
    showControls() {
      const { path } = this.$route;

      /* eslint-disable */
      return path.includes('service')
        || path.includes('station')
        || path.includes('date')
        || path.includes('confirm')
        && !path.includes('confirmed');
      /* eslint-enable */
    },
    subtitle() {
      const { path } = this.$route;

      if (path.includes('station')) {
        return 'Wybierz Partnera Serwisowego';
      }
      if (path.includes('service')) {
        return 'Wybierz zakres usług';
      }
      if (path.includes('date')) {
        if (!this.isMobile) {
          return 'Wybierz preferowany termin wizyty';
        }
        // eslint-disable-next-line
        return 'Wybierz preferowany dzień wizyty oraz jedną z proponowanych godzin oddania auta. Termin odbioru auta zostanie ustalony indywidualnie.';
      }
      if (path.includes('confirm') && !path.includes('confirmed')) {
        return 'Podaj dane kontaktowe';
      }

      return '';
    },
    headerText() {
      const routes = [
        'PickCarService',
        'PickServiceStation',
        'PickVisitDate',
        'ConfirmVisit',
        'ConfirmedVisit',
        'PickCarServiceNoAuth',
        'PickServiceStationNoAuth',
        'PickVisitDateNoAuth',
        'ConfirmVisitNoAuth',
        'ConfirmedVisitNoAuth',
      ];
      const editRoutes = [
        'EditCarService',
        'EditServiceStation',
        'EditVisitDate',
        'EditConfirmVisit',
        'EditConfirmedVisit',
      ];

      if (routes.includes(this.$route.name)) {
        return 'Nowa wizyta';
      } if (editRoutes.includes(this.$route.name)) {
        return 'Edytuj wizytę';
      }

      return 'Wizyty serwisowe';
    },
  },
  methods: {
    ...mapActions({
      setShowHistoryVisits: 'visit/setShowHistoryVisits',
    }),
    onToggle(value) {
      this.setShowHistoryVisits(value);
    },
  },
  beforeRouteLeave(to, from, next) {
    this.setShowHistoryVisits(false);
    next();
  },
};
</script>
